import React, {FC} from "react";
import {UserPatrol} from "../../../../domain/patrol/Patrol";

type Props = {
    item: UserPatrol;
};

export const PatrolRowZone: FC<Props> = ({item}) => {
    const {zone, submoduleId} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>ZONA</span>
            <span>{zone ? zone.label : submoduleId}</span>
        </div>
    );
};
